import { useContext } from "react";
import { AppContext } from "../Theme";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import "../main.css";
import Logs from "../components/logs/logs";

export default function LogsPage() {
	const { darkmode, toggleMode } = useContext(AppContext);

	return (
		<>
			<div className="sidebar-component">
				<Sidebar mode={darkmode} toggleMode={toggleMode} />
			</div>
			<div className="navbar-component">
				<Navbar mode={darkmode} username="Nexcare" />
			</div>
			<Logs mode={darkmode} />
		</>
	);
}
